module.exports = __webpack_public_path__ + "img/card1.90b095ca.jpg";